<template>
    <div class="primary-btn">
     <button class="oBtn" type="button" :class="[{'btn-disabled': disabled}]" :disabled="disabled" @click="hdlClick"><svg v-show="icon !=undefined" :class="this.icon"></svg>{{label}}</button>
    </div>
</template>

<script>
export default {
  name: "oButton",
  props:["buttonText","icon", "disabled"],
  data() {
    return {
       label: this.buttonText,
    };
  },
  methods: {
   hdlClick(e){
     this.$emit('click', e);
   }
  }
};
</script>


<style scoped>
.oBtn {
  border: var(--o-border);
  padding: var(--o-padding);
  background-color: var(--o-primary);
  color: var(--o-text-on-bg);
  font-size: var(--o-text-size);
  font-weight: var(--o-text-weight);
}
.btn-disabled{
  background-color: var(--o-disable);
  color: var(--o-bg1);
}
.btn-refresh button{
 background-color:transparent;
 color: var(--o-primary);
 font-size: 30px;
 cursor: pointer;
}
.job-window-close {
  align-self: flex-end;
  background-color: var(--o-bg1);
}
.job-window-close button{
  padding: 0;
  background-color: var(--o-text-on-bg); 
  cursor: pointer;
}
.job-window-close button svg{
  color: var(--o-primary); 
  font-size: 24px;
}
.job-window-close button:focus, .toggleStatus button:focus{
  outline: 0;
}
</style>